import React from "react"

import Layout from "../../components/Layout"
import SEO from "../../components/SEO"


const IndexWorkPage = () => (
  <Layout>
    <SEO title="WORK" keywords={[]}/>
  </Layout>
);

export default IndexWorkPage
